import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { generateMyAvatar } from "../api/avatar";

// يولّد أفاتار المستخدم مرة واحدة تلقائياً (بلا فتح الإعدادات). الخادم محمي بقفل + idempotent،
// فلا توليد مكرر ولا استبدال. إن لم توجد صورة مرجعية (422) نتجاهل بصمت.
const attempted = new Set();

export const useEnsureAvatar = () => {
  const { user, patchUser } = useAuth();
  useEffect(() => {
    if (!user || user.avatar) return;
    const id = user.id || user._id;
    if (!id || attempted.has(id)) return;
    attempted.add(id);
    generateMyAvatar()
      .then(({ avatar }) => {
        if (avatar) patchUser({ avatar });
      })
      .catch(() => {});
  }, [user, patchUser]);
};
